import React from 'react';

/**
 * USOKIE Platform Status Badge Component
 * Design: Black (#000), Bone (#fffbf7), Sage (#a1c6a2), Amber (#d4a574), Red (#c47474)
 */

const statusStyles = {
  // Success/Active states
  active: 'border-[#a1c6a2] text-[#a1c6a2] bg-[rgba(161,198,162,0.1)]',
  signed: 'border-[#a1c6a2] text-[#a1c6a2] bg-[rgba(161,198,162,0.1)]',
  verified: 'border-[#a1c6a2] text-[#a1c6a2] bg-[rgba(161,198,162,0.1)]',
  approved: 'border-[#a1c6a2] text-[#a1c6a2] bg-[rgba(161,198,162,0.1)]',
  live: 'border-[#a1c6a2] text-[#a1c6a2] bg-[rgba(161,198,162,0.1)]',
  complete: 'border-[#a1c6a2] text-[#a1c6a2] bg-[rgba(161,198,162,0.1)]',

  // Warning/Pending states
  pending: 'border-[#d4a574] text-[#d4a574] bg-[rgba(212,165,116,0.1)]',
  pending_signature: 'border-[#d4a574] text-[#d4a574] bg-[rgba(212,165,116,0.1)]',
  draft: 'border-[#d4a574] text-[#d4a574] bg-[rgba(212,165,116,0.1)]',
  submitted: 'border-[#60a5fa] text-[#60a5fa] bg-[rgba(96,165,250,0.1)]',
  revision_requested: 'border-[#f0ad4e] text-[#f0ad4e] bg-[rgba(240,173,78,0.1)]',
  setup: 'border-[#d4a574] text-[#d4a574] bg-[rgba(212,165,116,0.1)]',
  production: 'border-[#60a5fa] text-[#60a5fa] bg-[rgba(96,165,250,0.1)]',
  shipping: 'border-[#60a5fa] text-[#60a5fa] bg-[rgba(96,165,250,0.1)]',

  // Error/Inactive states
  expired: 'border-[#c47474] text-[#c47474] bg-[rgba(196,116,116,0.1)]',
  terminated: 'border-[#c47474] text-[#c47474] bg-[rgba(196,116,116,0.1)]',
  cancelled: 'border-[#c47474] text-[#c47474] bg-[rgba(196,116,116,0.1)]',
  rejected: 'border-[#c47474] text-[#c47474] bg-[rgba(196,116,116,0.1)]',

  // Neutral states
  inactive: 'border-[rgba(255,251,247,0.3)] text-[rgba(255,251,247,0.5)] bg-[rgba(255,251,247,0.05)]',
  default: 'border-[rgba(255,251,247,0.2)] text-[rgba(255,251,247,0.6)] bg-black',
};

const StatusBadge = ({ status, className = '' }) => {
  const normalizedStatus = status?.toLowerCase().replace(/\s+/g, '_');
  const style = statusStyles[normalizedStatus] || statusStyles.default;

  const displayText = status?.replace(/_/g, ' ') || 'Unknown';

  return (
    <span
      className={`px-2 py-1 text-[10px] tracking-wider uppercase border ${style} ${className}`}
      style={{ fontFamily: "'GT Pressura Mono', monospace" }}
    >
      {displayText}
    </span>
  );
};

export default StatusBadge;
